export enum SearchEngine {
  DTSearch = 'DTSearch',
  Solr = 'Solr',
  OpenSearch = 'OpenSearch',
}
